<template>
  <div class="input-select-dropdown" :class="{'open': open}" @click="open = !open">
    <div class="selected" >{{ selected ? selected.display : placeholder || 'Vælg...' }}</div>
    <transition name="slide-down">
      <div class="options" v-if="open">
        <div class="option" v-for="(option, i) in options" :key="i" :class="{ 'selected': selected && option.value === selected.value }"  @click="selectOption(i)" ref="options">{{ option.display }}</div>
      </div>
    </transition>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType, ref, onMounted } from 'vue'

interface InputSelectOption {
  value: string | number;
  display: string | number;
}

export default defineComponent({
  name: 'InputSelect',
  emits: ['update:modelValue', 'select'],
  props: {
    modelValue: [String, Number, Boolean] as PropType<string | number | null>,
    options: {
      type: Object as PropType<InputSelectOption[]>,
      required: true
    },
    placeholder: String
  },
  setup(props, { emit }) {
    const selected = ref<InputSelectOption | null>(null)
    const open = ref(false)

    function selectOption(i: number) {
      selected.value = props.options[i]
      emit('update:modelValue', props.options[i].value)
      emit('select', props.options[i].value)
    }

    onMounted(() => {  
      selected.value = props.options.find(obj => obj.value ===  props.modelValue) || null
    })

    return { selectOption, selected, open }
  }
})
</script>

<style scoped lang='scss'>
.input-select-dropdown {
    //background-color: rgba(0, 0, 0, 0.02);
    position: relative;
    display: flex;
    position: relative;
    align-items: center;
    background: var(--color-background-input);
    border-radius: 1rem;
    height: 3rem;
    min-width: 10rem;
    flex: 10rem 1 1;
    z-index: 100;
    padding: 0 2.5rem 0 1rem;
    cursor: pointer;

    &:before {
      content: "keyboard_arrow_down";
      font-family: 'Material Icons';
      position: absolute;
      right: 1rem;
      transition: transform .3s;
    }
    &.open:before {
      transform: rotate(180deg);
    }

    &.open {
      z-index: 1000000;
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
      box-shadow: var(--card-shadow);
      .options {
        box-shadow: var(--card-shadow);
      }
      .selected {
        opacity: 0.5;
      }
    }

    .options {
      position: absolute;
      background: var(--color-background-input);
      top: 2.5rem;
      left: 0;
      right: 0;
      padding: .5rem 0;
      border-bottom-left-radius: 1rem;
      border-bottom-right-radius: 1rem;
    }

    .option {
        transition: color .3s ease;
        font-weight: bold;
        line-height: 20px;
        user-select: none;
        display: flex;
        align-items: center;
        padding: .5rem 1rem;
        position: relative;

        &.selected {
            color: var(--color-primary) !important;
            &:before {
              content: "check";
              font-family: "Material Icons";
              font-size: 1rem;
              position: absolute;
              right: 1rem;
              top: .5rem;
              color: var(--color-primary);
            }
        }
        &:hover {
          opacity: 0.75;
        }
    }
}


</style>
